import { images, highlights } from "../data";
import { Flame, Pizza, Bike } from "lucide-react";
import { useReveal } from "../hooks/useReveal";

const icons = [Flame, Pizza, Bike];

export default function Highlights() {
  const { ref, inView } = useReveal();
  return (
    <section className="relative z-10 bg-[#0f0f0f] py-20 md:py-28">
      <div ref={ref} className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className={`reveal ${inView ? "in-view" : ""}`}>
            <span className="font-script text-3xl text-[#eab308]">Herzlich willkommen</span>
            <h2 className="mt-2 font-display font-black text-4xl md:text-5xl text-[#f5f5f0] leading-tight">
              Echter Geschmack aus <span className="text-[#e05d36]">Krefeld</span>
            </h2>
            <p className="mt-5 text-[#a3a3a3] text-lg leading-relaxed max-w-lg">
              Seit Jahren stehen wir für saftigen Döner vom Drehspieß und knusprige
              Pizza aus dem Steinofen. Frische Zutaten, faire Preise und ein Team,
              das mit Leidenschaft für dich kocht.
            </p>

            <div className="mt-10 grid sm:grid-cols-3 gap-5">
              {highlights.map((h, i) => {
                const Icon = icons[i];
                return (
                  <div
                    key={h.title}
                    data-testid={`highlight-${i}`}
                    className="rounded-2xl bg-[#1a1a1a] border border-white/10 p-5 hover:border-[#e05d36]/50 transition-colors duration-200"
                  >
                    <div className="grid place-items-center h-11 w-11 rounded-full bg-[#e05d36]/15 text-[#e05d36]">
                      <Icon size={22} />
                    </div>
                    <h3 className="mt-4 font-display font-bold text-[#f5f5f0]">{h.title}</h3>
                    <p className="mt-1 text-sm text-[#a3a3a3] leading-relaxed">{h.text}</p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className={`reveal ${inView ? "in-view" : ""} grid grid-cols-2 gap-4`} style={{ animationDelay: "0.15s" }}>
            <img src={images.donerHeld} alt="Döner" className="rounded-2xl h-64 md:h-80 w-full object-cover border border-white/10 mt-8" />
            <img src={images.pizza} alt="Pizza" className="rounded-2xl h-64 md:h-80 w-full object-cover border border-white/10" />
          </div>
        </div>
      </div>
    </section>
  );
}
